import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const ToolWrapper = styled.div`
  margin-left: 30px;
`;

export const ComponentWrapper = styled.div`
`;

export const Code = styled.pre`
  background-color: #dddddd;
  margin: 20px;
  padding: 20px;
`;
